import React from 'react';
import { Tag } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';

type CheckButtonProps = {
  label?: string;
  isActive?: boolean;
  onClick?: () => void;
};

const MinusTagButton = ({ onClick, isActive = true, label = 'No' }: CheckButtonProps) => {
  const color = isActive ? 'red' : undefined;
  const style = { cursor: !onClick ? 'default' : 'pointer' };

  return (
    <Tag icon={<CloseCircleOutlined />} color={color} style={style} onClick={onClick}>
      {label}
    </Tag>
  );
};

export default MinusTagButton;
